import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { TranslatePipe } from '@ngx-translate/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';

@Component({
  selector: 'wilson-training-qualifications-finalize-notes-section',
  imports: [
    FormsModule,
    NzCollapseModule,
    NzFormModule,
    ReactiveFormsModule,
    TranslatePipe,
    NzInputModule,
  ],
  templateUrl:
    './training-qualifications-finalize-notes-section.component.html',
  styleUrl: './training-qualifications-finalize-notes-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrainingQualificationsFinalizeNotesSectionComponent {
  @Input() active: boolean | null = true;
  @Input() disabled: boolean | null = false;

  @Input() notesFormControl: FormControl<string | null> = new FormControl<
    string | null
  >(null);
}
